import { useEffect, useContext } from 'react'
import { AppContext } from '../../../stores/App/AppStore'
import { useBundleRepository } from '../../../repositories/Bundle/use-bundle-repository'
import { Container, Grid, Skeleton } from '@mui/material'
import CommonBackButton from '../../atoms/CommonBackButton/CommonBackButton'
import MarkdownContent from "../../atoms/MarkdownContent/MarkdownContent"
import { useNavigate, useParams } from 'react-router-dom'
import styles from "./BundleSignUpLandingPage.module.css"
import useTrackPageView from '../../../helpers/hooks/use-track-page-view'
import SignUpButton from '../../atoms/SignUpButton/SignUpButton'
import GtmEventName from '../../../helpers/analytics/GtmEventName'
import LocalStorageKeys from '../../../types/LocalStorageKeys'
import { MyInfoReason } from '../../../types/MyInfoUserData'
import { logLandingPageAction } from '../../../clients/logger'
import useGoogleTagManager from '../../../helpers/analytics/use-google-tag-manager'
import { Route, STRAPI_URL } from '../../../router'
import moment from 'moment'
import ConfirmationDialog from '../../molecules/ConfirmationDialog/ConfirmationDialog'
import { useTranslation } from 'react-i18next'

const BundleSignUpLandingPage = () => {
    const { state: appState } = useContext(AppContext)
    const { trackButtonClick } = useGoogleTagManager()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { retrieveBundle, saveBundleCode } = useBundleRepository()

    useEffect(() => {
        if (bundleCode) {
            saveBundleCode(bundleCode)
            retrieveBundle(bundleCode)
        }
    }, [])

    const { bundle } = useParams()
    const bundleCode = bundle?.toUpperCase()

    useTrackPageView(() => {
        if (appState.pages.bundle) {
            return {
                title: `Bundle Landing Page`,
                item: appState.pages.bundle.name,
            }
        }
    }, [bundle])

    const handleSignUpButtonClick = () => {
        trackButtonClick(GtmEventName.SIGN_UP_CLICK, appState.pages.bundle?.code)
        localStorage.setItem(LocalStorageKeys.MYINFO_REASON, MyInfoReason.SIGNUP)
        logLandingPageAction(`Sign Up`,`bundle`, appState.pages.bundle?.name)
        window.location.href = `${STRAPI_URL}${Route.MYINFO_AUTHORISE}`
    }

    if (!appState.pages.bundle) {
        return (
            <Container>
                <CommonBackButton path="/" />
                <Grid item width='100%'>
                    <Skeleton variant='rectangular' width='100%' height='40vw' />
                </Grid>
            </Container>
        )
    }

    if (appState.pages.bundle){
        const startDate = moment(appState.pages.bundle.startDate)
        const endDate = moment(appState.pages.bundle.endDate)
        if (startDate.isAfter(moment()) || endDate.isSameOrBefore(moment())) {
            return (
                <Container>
                    <CommonBackButton path="/" />
                    <Grid item width='100%'>
                        <Skeleton variant='rectangular' width='100%' height='40vw' />
                    </Grid>
                    <ConfirmationDialog
                        buttonText={t(`common_button_confirmation`)}
                        confirmationTitle={`Information`}
                        confirmationText={`This bundle is not available for sign up`}
                        defaultOpen={true}
                        acknowledgeOnly={true}
                        onConfirm={()=> navigate(Route.ROOT)}
                        onDismiss={()=> navigate(Route.ROOT)}
                    />
                </Container>
            )
        }
    }

    return (
        <Container>
            <MarkdownContent
                content={appState.pages.bundle.content}
                className={styles.markdownContent}
            />
            <SignUpButton onClick={handleSignUpButtonClick} />
        </Container>
    )
}

export default BundleSignUpLandingPage